import React, { useState } from 'react';
import axios from 'axios';
import { ClipLoader } from "react-spinners";
import { useNavigate } from 'react-router-dom';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import SaveIcon from '@mui/icons-material/Save';

function AddCars() {
  const [carCategory, setCarCategory] = useState('');
  const [passengerCount, setPassengerCount] = useState(0);
  const [remark, setRemark] = useState('');
  const [rate, setRate] = useState('');
  const [carImage, setCarImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [nextId] = useState(null);

  const navigate = useNavigate();

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append('carID', nextId);
    formData.append('carCategory', carCategory);
    formData.append('passengerCount', passengerCount);
    formData.append('remark', remark);
    formData.append('rate', rate);
    if (carImage) {
      formData.append('carImage', carImage);
    }

    try {
      await axios.post('https://genzserver.mylksystems.com/Cars/createCar', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      setLoading(false);
      setCarCategory('');
      setPassengerCount(0);
      setRemark('');
      setRate('');
      setCarImage(null);

      navigate('/ManageCars');
    } catch (error) {
      console.error('Error submitting car:', error);
      alert('Submission failed. Check console for details.');
      setLoading(false);
    }
  };

  return (
    <div className="page-shell page-shell-narrow">
      <header className="page-header">
        <div>
          <span className="eyebrow">Rental fleet</span>
          <h1 className="page-title">Add a new car</h1>
          <p className="page-copy">
            Keep rental options easy to compare with category, capacity, rate, and a clean vehicle image.
          </p>
        </div>
      </header>

      <div className="admin-card form-card">
        <form onSubmit={handleFormSubmit} className="form-grid">
          <section className="section-card">
            <h2 className="section-title">Vehicle Details</h2>
            <div className="form-grid">
              <div className="field">
                <label>Car Category</label>
                <input
                  type="text"
                  value={carCategory}
                  onChange={(e) => setCarCategory(e.target.value)}
                  placeholder="Enter car category"
                  required
                />
              </div>

              <div className="field">
                <label>Passenger Count</label>
                <input
                  type="number"
                  value={passengerCount}
                  onChange={(e) => setPassengerCount(parseInt(e.target.value, 10) || 0)}
                  placeholder="Enter the number of passengers"
                  required
                />
              </div>

              <div className="field">
                <label>Remark</label>
                <textarea
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                  rows={3}
                  placeholder="Enter remarks about the car"
                  required
                />
              </div>

              <div className="field">
                <label>Rate</label>
                <input
                  type="text"
                  value={rate}
                  onChange={(e) => setRate(e.target.value)}
                  placeholder="Enter rental rate"
                  required
                />
              </div>
            </div>
          </section>

          <section className="section-card">
            <h2 className="section-title">Gallery Image</h2>
            <div className="field">
              <label>Car Image</label>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => setCarImage(e.target.files[0])}
                required
              />
            </div>
          </section>

          <button type="submit" className="admin-button" disabled={loading}>
            {loading ? <ClipLoader color="#ffffff" size={20} /> : <SaveIcon fontSize="small" />}
            {loading ? 'Submitting...' : 'Submit Car'}
          </button>

          <div className="form-note">
            <DirectionsCarIcon fontSize="small" /> Vehicle images display in the rental management gallery after submission.
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddCars;
